var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value || _vm.value === 0,
        label: "転職回数",
        half: "",
      },
    },
    [
      _c(
        "select",
        {
          staticClass: "boss-input-select",
          attrs: { "data-test": "select-changed-jobs" },
          domProps: { value: _vm.value },
          on: {
            change: function ($event) {
              _vm.$emit(
                "input",
                $event.target.value ? Number($event.target.value) : null
              )
            },
          },
        },
        [
          _c("option", { attrs: { value: "" } }, [
            _vm._v("\n      指定なし\n    "),
          ]),
          _vm._v(" "),
          _vm._l(_vm.options, function (option, i) {
            return _c("option", { key: i, domProps: { value: option.id } }, [
              _vm._v("\n      " + _vm._s(option.name) + "\n    "),
            ])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }